import { render, staticRenderFns } from "./ChatInfoMedia.vue?vue&type=template&id=04b3e7d5&scoped=true&"
import script from "./ChatInfoMedia.vue?vue&type=script&lang=js&"
export * from "./ChatInfoMedia.vue?vue&type=script&lang=js&"
import style0 from "./ChatInfoMedia.vue?vue&type=style&index=0&id=04b3e7d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b3e7d5",
  null
  
)

export default component.exports